import 'core-js/stable';
import 'regenerator-runtime/runtime';
import './widgetHeader.css';
import FontFaceObserver from 'fontfaceobserver';
import { render as renderCore } from 'ia-react-core';
import App from './app';
import logger from './utils/logger';

const render = () => {
  renderCore(App);
};

const montserrat = new FontFaceObserver('Montserrat');
const openSans = new FontFaceObserver('Open Sans');

// eslint-disable-next-line @typescript-eslint/no-floating-promises
Promise.all([
  montserrat.load(),
  openSans.load(),
]).catch(() => {
  logger.warn('Fonts could not be loaded');
}).finally(() => {
  render();
});
